
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import './index.css';
import { AppKitProvider } from '@lib/wallet/appKit';
import { initPostHog } from '@lib/analytics/posthog';

const posthog = initPostHog();
const app = (
  <AppKitProvider>
    <App />
  </AppKitProvider>
);

createRoot(document.getElementById('root')!).render(
  posthog ? <PostHogProvider client={posthog}>{app}</PostHogProvider> : app,
);
